/**
 * Billing permission-gating messages, ported from the Ember `app/utils/route-access.ts`
 * constants. Used by the billing service to explain why an upgrade / billing action is
 * disabled (verification rejected, masquerading read-only, or missing permission).
 */

const VERIFICATION_REJECTED_BODY_BEFORE_AUP =
  'Your account was not approved because the email domain and website information you provided at signup does not align with our ';
const VERIFICATION_REJECTED_BODY_AFTER_AUP = '. If you believe this is an error, please ';
const VERIFICATION_REJECTED_CONTACT_SUPPORT_TEXT = 'contact support';

export const VERIFICATION_REJECTED_MESSAGE = `${VERIFICATION_REJECTED_BODY_BEFORE_AUP}Acceptable Use Policy${VERIFICATION_REJECTED_BODY_AFTER_AUP}${VERIFICATION_REJECTED_CONTACT_SUPPORT_TEXT}.`;

export const MASQ_READ_ONLY_MESSAGE = 'You cannot make changes while in read-only mode.';

export const NO_BILLING_PERMISSION_MESSAGE = 'You do not have permission to manage billing.';
